import React from 'react';
import '../App.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import AppFooter from '../components/Footer.js';
import AppNavbar from '../components/Navbar.js';
import Image from 'react-bootstrap/Image';
import Character from '../assets/images/Character.svg';
import styled, { keyframes } from 'styled-components';

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
`;

const ComingSoonSection = styled.div`
  min-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 100%);
  padding: 4rem 1rem;
  position: relative;
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 32px;
  padding: 4rem 2rem;
  box-shadow: 0 24px 50px rgba(0,0,0,0.05);
  animation: ${fadeIn} 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  max-width: 800px;
  margin: 0 auto;
`;

const HeroTitle = styled.h1`
  font-weight: 800;
  font-size: clamp(2.5rem, 5vw, 4rem);
  color: var(--primary-color-dark);
  margin-bottom: 1.2rem;
  letter-spacing: -1px;
`;

const SubText = styled.p`
  font-size: 1.15rem;
  color: #4a5568;
  margin-bottom: 2.5rem;
  line-height: 1.7;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
`;

const FloatingImage = styled(Image)`
  animation: ${float} 6s ease-in-out infinite;
  max-width: 100%;
  height: auto;
`;

const ImageContainer = styled.div`
  max-width: 380px;
  margin: 3rem auto 0;
`;

export default function AppComing() {
  return (
    <>
      <header>
        <AppNavbar />
      </header>

      <main style={{ paddingTop: '80px' }}>
        <ComingSoonSection>
          <Container>
            <ContentWrapper>
              <Row className="align-items-center text-center">
                <Col md={12}>
                  <HeroTitle>We're building something amazing.</HeroTitle>
                  <SubText>
                    Take our survey to join the waitlist and we will let you know immediately when we go live.
                  </SubText>
                  
                  <a href="https://forms.gle/hr6CDWU1twzL9ttu5" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <Button className="btn-primary-custom" style={{ padding: '1rem 2.5rem', fontSize: '1.1rem', borderRadius: '50px' }}>
                      Take the Survey
                    </Button>
                  </a>
                  
                  <ImageContainer>
                    <FloatingImage src={Character} alt="Coming soon character" fluid />
                  </ImageContainer>
                </Col>
              </Row>
            </ContentWrapper>
          </Container>
        </ComingSoonSection>
      </main>
      
      <footer>
        <AppFooter />
      </footer>
    </>
  );
}